import InteractiveQuiz from '../components/InteractiveQuiz';

const Quiz: React.FC = () => {
    const scrollToForm = () => {
        const formSection = document.getElementById('form-section');
        if (formSection) {
            formSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const faqData = [
        {
            question: "As questões são inéditas ou retiradas de provas anteriores?",
            answer: "Todas as questões são inéditas focadas numa estratégia de estudo, conforme os conteúdos que mais caem na prova do TEOC. Estudo acurado e assertivo!"
        },
        {
            question: "Quem elaborou o conteúdo?",
            answer: "As questões foram elaboradas pela equipe Teraquiz, coordenada por Otavio Moreira, médico oncologista clínico formado no ICESP-FMUSP e titulado pela SBOC."
        },
        {
            question: "As questões seguem quais referências?",
            answer: "As referências das questões são comentadas baseando-se nos principais guidelines mundiais, entre eles ASCO, ESMO, NCCN, MOC, SBOC, entre outros."
        },
        {
            question: "Como recebo o acesso após a compra?",
            answer: "O acesso é 100% online e imediato — assim que o pagamento é confirmado, você recebe seu login e senha para estudar onde e quando quiser."
        },
        {
            question: "Posso acessar pelo celular?",
            answer: "Sim. A plataforma é responsiva e funciona perfeitamente no celular, tablet ou computador."
        },
        {
            question: "Quanto tempo terei acesso ao banco de questões?",
            answer: "O acesso é válido por 12 meses a partir da data da compra."
        },
        {
            question: "Esse material substitui meus livros e apostilas?",
            answer: "Não substitui, mas potencializa seus estudos. As questões funcionam como um treino ativo e revisão rápida, complementando o estudo teórico."
        },
        {
            question: "Há garantia de satisfação?",
            answer: "Sim. Você tem 7 dias para testar o banco de questões. Se não estiver satisfeito, devolvemos seu dinheiro sem burocracia."
        },
        {
            question: "O banco simula a prova real?",
            answer: "Sim. Há um modo simulado que replica o formato e o tempo da prova de Título em Oncologia, além do modo de treino para estudar questão por questão com comentários."
        }
    ];

    return (
        <div className="min-h-screen" style={{backgroundColor: '#0b0b36'}}>
            <InteractiveQuiz scrollToForm={scrollToForm} faqData={faqData} />

            <footer className="text-white py-8" style={{backgroundColor: '#0b0b36'}}>
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col text-center items-center">
                        <img src={'https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1755884655932806641_68a8ac6f.webp'} alt="TeraQuiz" className="h-10 mb-6" />
                        <div className="flex justify-center space-x-6 mb-6">
                            <a href="https://chat.whatsapp.com/LI0H299ybJlAohNFsygfnn?mode=ems_copy_c" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity" style={{color: '#c1ff72'}}>
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/oncoteraquiz?igsh=M2JkNGJndThuN3U2&utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity" style={{color: '#ff6b9d'}}>
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                </svg>
                            </a>
                        </div>
                        <div className="border-t border-white/20 pt-6">
                            <p className="text-gray-300 text-xs mb-3">
                                © 2025 Teraquiz. Todos os direitos reservados.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Quiz;